import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.min.css';
import { withProfiler } from '@sentry/react';
import Routes from './routes/index';

const App = ({ store }) => (
  <Provider store={store}>
    <Routes />
  </Provider>
);

App.propTypes = {
  store: PropTypes.object.isRequired,
};

export default withProfiler(App);
